module.exports = __webpack_public_path__ + "media/images/iconSocialMail__inactive--dark-260898d282c31a7c79d94f49a50804c2.png";